import './styles/modal.scss'
import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

function exampleReducer(state, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { open: true, dimmer: action.dimmer }
    case 'CLOSE_MODAL':
      return { open: false }
    default:
      throw new Error()
  }
}

function ModalComponent() {
  const [state, dispatch] = React.useReducer(exampleReducer, {
    open: true,
    dimmer: undefined
  })
  const { open } = state

  return (
    <div>
      <Modal
       size="mini"
        open={open}
        onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
      >
        <Modal.Content className="error-modal">
        	Something went wrong. Try reloading page.
        </Modal.Content>
        <Modal.Actions className="error-modal">
          <Button  positive onClick={() => {dispatch({ type: 'CLOSE_MODAL' });window.location=window.location.origin}}>
            Reload Page
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default ModalComponent